import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-dialog modal-lg modal-dialog-scrollable" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = {
  class: "alert alert-danger text-dark",
  role: "alert"
}
const _hoisted_10 = { class: "modal-footer" }

import { computed, toRef } from 'vue'
    import AlternativesViewDependenciesList from '@Alternatives/AlternativesViews/Components/AlternativesViewDependenciesList.vue'
    import type { AlternativesViewDeleterDialogViewModel } from '@Alternatives/AlternativesViews/Components/AlternativesViewDeleterDialog'

    // ---------------- props / emits ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'AlternativesViewDeleterDialog',
  props: {
    viewModel: {}
  },
  emits: ["delete-list"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    const emit = __emit

    // ---------------- shortcuts ----------------

    const vm = toRef(props, 'viewModel')

    // ---------------- derived ----------------

    const opened = computed(() => vm.value?.opened ?? false)
    const initialized = computed(() => vm.value?.initialized ?? false)

    const canDelete = computed(() => vm.value?.hasDependants === false)

    const name = computed(() => vm.value.name)
    const dependenciesCount = computed(() => vm.value.dependenciesCount)

    const reports = computed(() => vm.value.reports)
    const lists = computed(() => vm.value.lists)
    const estimationsSurveys = computed(() => vm.value.estimationsSurveys)

    // ---------------- methods ----------------

    function deleteList()
    {
        emit('delete-list', vm.value.id)
    }

    function close()
    {
        vm.value.close()
    }

return (_ctx: any,_cache: any) => {
  return (opened.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", {
                class: _normalizeClass(["modal-header", {'bg-danger': canDelete.value}])
              }, [
                _cache[0] || (_cache[0] = _createElementVNode("h5", { class: "modal-title" }, "Delete attribute", -1 /* CACHED */)),
                _createElementVNode("button", {
                  type: "button",
                  class: "close",
                  onClick: close
                }, "×")
              ], 2 /* CLASS */),
              _createElementVNode("div", _hoisted_5, [
                (!initialized.value)
                  ? (_openBlock(), _createElementBlock("h4", _hoisted_6, [...(_cache[1] || (_cache[1] = [
                      _createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1 /* CACHED */),
                      _createTextVNode(" Checking dependencies... ", -1 /* CACHED */)
                    ]))]))
                  : _createCommentVNode("v-if", true),
                (canDelete.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _cache[4] || (_cache[4] = _createElementVNode("h4", null, "Are you sure you want to delete this list?", -1 /* CACHED */)),
                      _createElementVNode("p", null, [
                        _cache[2] || (_cache[2] = _createTextVNode("You are about to delete '", -1 /* CACHED */)),
                        _createElementVNode("strong", null, _toDisplayString(name.value), 1 /* TEXT */),
                        _cache[3] || (_cache[3] = _createTextVNode("'. This can't be undone.", -1 /* CACHED */))
                      ])
                    ]))
                  : _createCommentVNode("v-if", true),
                (!canDelete.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _cache[8] || (_cache[8] = _createElementVNode("h5", { class: "alert-heading" }, "Cannot delete this list", -1 /* CACHED */)),
                        _createElementVNode("p", null, [
                          _cache[5] || (_cache[5] = _createTextVNode(" The list '", -1 /* CACHED */)),
                          _createElementVNode("strong", null, _toDisplayString(name.value), 1 /* TEXT */),
                          _cache[6] || (_cache[6] = _createTextVNode("' is used in ", -1 /* CACHED */)),
                          _createElementVNode("strong", null, _toDisplayString(dependenciesCount.value), 1 /* TEXT */),
                          _cache[7] || (_cache[7] = _createTextVNode(" places. To delete this list, first remove it from where it is used. ", -1 /* CACHED */))
                        ])
                      ]),
                      _createVNode(AlternativesViewDependenciesList, {
                        initialized: initialized.value,
                        reports: reports.value,
                        lists: lists.value,
                        estimationsSurveys: estimationsSurveys.value
                      }, null, 8 /* PROPS */, ["initialized", "reports", "lists", "estimationsSurveys"])
                    ]))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("div", _hoisted_10, [
                (canDelete.value)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn btn-danger",
                      onClick: deleteList
                    }, "Delete"))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-outline-secondary",
                  onClick: close
                }, "Cancel")
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})